import React from 'react';
import styled from 'styled-components';
import aboutImg from '../../Asset/img/about.jpg';
import logoImg from '../../Asset/img/bluspace-w.png';
const AboutBanner = () => {
  return (
    <AboutBannerWrapper>
      <AboutTextWrapper>
        <div className="head">
          <span>|| Bluspace </span>
          <h1>Who We Are</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt
            voluptates ab maiores, perferendis blanditiis reprehenderit.
          </p>
        </div>
        <div className="bio-box">
          <h4>|| Mission</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Consequuntur, nulla? Dolores omnis cupiditate consequuntur,
            recusandae suscipit maiores dolor, porro ducimus perspiciatis
            molestias voluptatibus quidem alias?
          </p>
        </div>
        <div className="bio-box">
          <h4>|| Vision</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Consequuntur, nulla? Dolores omnis cupiditate consequuntur,
            recusandae suscipit maiores dolor, porro ducimus perspiciatis
            molestias voluptatibus quidem alias?
          </p>
        </div>
      </AboutTextWrapper>
      <AboutImgWrapper>
        <div className="imgBox">
          <img src={aboutImg} alt="our banner" />
        </div>
        <div className="text-box">
            <img src={logoImg} alt="logo" />
        </div>
      </AboutImgWrapper>
    </AboutBannerWrapper>
  );
};

const AboutBannerWrapper = styled.section`
  padding: 100px 20px;
  display: grid;
  grid-template-columns: 58% 40%;
  gap: 2%;

  @media screen and (max-width: 768px){
   grid-template-columns: 100%;
  }


  @media screen and (max-width: 430px){
    grid-template-columns: 100%;
    padding: 8rem 20px;
  }
`;

const AboutTextWrapper = styled.article`
  .head {
    span {
      font-weight: 700;
      color: var(--bg-color);
    }
    h1 {
      font-size: 2.3rem;
      font-weight: 700;
      padding: 15px 0;
    }

    p {
      font-size: 1.04rem;
      font-weight: 600;
      color: var(--text-color);
      line-height: 1.7;
      max-width: 490px;
    }
  }

  .bio-box {
    padding: 10px 0;

    h4 {
      color: var(--bg-color);
      font-size: 15px;
      font-weight: 700;
    }

    p {
      margin: 8px 0;
      max-width: 600px;
      font-size: 1.04rem;
      color: var(--text-color);
      line-height: 1.7;
      text-align: justify;
    }
  }
`;
const AboutImgWrapper = styled.article`
  position: relative;
  .imgBox {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      border-radius: .2rem;
    }
  }

  .text-box{
    background: linear-gradient(var(--bg-color), var(--ico-color));
    border-radius: .2rem;
    box-shadow: 0 .5rem 1rem var(--bga-color);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    transform: translate(-1.5rem, 2rem);
    transition: all 2s ease-in-out;

    img{
        width: 100%;
    }
  }

  &:hover{
    .text-box{
        opacity: 0;
        visibility: hidden;
        transform: translate(0);
    }
  }

  @media screen and (max-width: 768px)  {
    .text-box{
      transform: translate(0, 10rem);
    }
  }

  @media screen and (max-width: 430px)  {
    .text-box{
      transform: translate(0, 8rem);
    }
  }
`;

export default AboutBanner;
